{
    "CookiesDescription": "We gebruiken cookies om uw ervaring met Akixi te verbeteren. Raadpleeg ons {}Cookiebeleid{} voor meer informatie over hoe en waarom we cookies gebruiken.",
    "CookieConsentChangeMessage": "Als u deze instelling wilt wijzigen, kunt u dat hieronder doen.",
    "AcceptedAllCookiesMessage": "Hoera! We hebben uw directory-items met succes geconfigureerd.",
    "AcceptedFunctionalCookiesMessage": "Hoera! We hebben uw directory-items met succes geconfigureerd.",
    "RejectedAllCookiesMessage": "U heeft alle cookies afgewezen. Dit betekent dat sommige functionaliteit van de applicatie niet zal werken.\n {}",
    "AcceptAllCookies": "Accepteer alles",
    "AcceptFunctionalityCookies": "Functionaliteitscookies accepteren",
    "RevokeAllCookies": "Alle toestemming intrekken",
    "RevokeStatisticsCookies": "Toestemming voor statistieken intrekken",
    "RejectAllCookies": "Alles afwijzen",
    "RejectionWarning": "Bevestig dat alles correct is getypt en ga dan verder met het importeren van het voltooide bestand hier (Eventuele fouten met het bestand worden opgemerkt tijdens de configuratie):",
    "NAME": "CookieConsent"
}